import { Component } from '@angular/core';

@Component({
  selector: 'lib-copy-icon',
  imports: [],
  templateUrl: './copy-icon.html',
  styleUrl: './copy-icon.scss',
})
export class CopyIcon {}
